import React from "react";
import PropTypes from "prop-types";
import { Image, imageProps } from "@atoms";
import classNames from "classnames";

/**
 *
 * `ImageBlock` Styled image for CopyImageBlock
 *
 */

const ImageBlock = ({ image, className, style, preserveAspectRatio }) => {
  return (
    <div
      className={classNames("ImageBlock relative", className, {
        "h-full": !preserveAspectRatio,
      })}
      style={{ ...style }}
    >
      <div
        className={classNames("shadow-image", {
          "absolute inset-0": !preserveAspectRatio,
        })}
      >
        <Image image={image} disableDrag />
      </div>
    </div>
  );
};

ImageBlock.propTypes = {
  image: imageProps.isRequired,
  className: PropTypes.string,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ),
  preserveAspectRatio: PropTypes.bool,
};

ImageBlock.defaultProps = {
  className: "",
  style: {},
  preserveAspectRatio: false,
};

export default ImageBlock;
